import { createUseStyles } from "react-jss";
import { ITheme } from "../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    overflowY: "scroll",
    overflowX: "hidden",
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
    padding: `${theme.spacing.space8}px 0`,
    boxSizing: "border-box",
  },
  tabsList: {
    padding: `0 ${theme.spacing.space24}px`,
  },
  content: {
    marginTop: 70,
    gap: theme.spacing.space24,
    display: "flex",
    flexDirection: "column",
  },
  tabContent: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space16,
  },
  tabTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: `0 ${theme.spacing.space24}px`,
  },
  listInventories: {
    display: "flex",
    flexDirection: "row",
    overflowX: "scroll",
    gap: theme.spacing.space8,
    padding: `0 ${theme.spacing.space24}px`,
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  listAvatars: {
    display: "grid",
    padding: `0 ${theme.spacing.space24}px`,
    gridGap: theme.spacing.space8,
    gridTemplateColumns: "repeat(auto-fill, minmax(90px, 1fr))",
  },
  backdrop: {
    borderRadius: 318,
    background: "rgba(84, 72, 255, 0.20)",
    filter: " blur(50px)",
    width: 266,
    height: 318,
    zIndex: 0,
    position: "fixed",
    bottom: -70,
    right: 0,
  },
}));
